export default {
  operatedBy: 'Utförs av',
  partlyOperatedBy: 'Trafikeras delvis av',
  operatedByGerman: '',
}
